import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppTheme } from '../context/AppThemeContext';

export default function ThemeSelector() {
    const { t } = useTranslation();
    const { themeName, setThemeName } = useAppTheme();
    return <FormControl size="small" fullWidth sx={{ my: 1 }}>
        <InputLabel id="app-theme-label">{t('appearance.theme')}</InputLabel>
        <Select labelId="app-theme-label" label={t('appearance.theme')} value={themeName} onChange={event => setThemeName(event.target.value)}>
            {['daylight', 'evening', 'midnight', 'dawn'].map(name => <MenuItem key={name} value={name}>{t(`appearance.${name}`)}</MenuItem>)}
        </Select>
    </FormControl>;
}
